import { Box, Link } from "@mui/material";
import { Button } from "@samdesk/components/Button";
import { Form } from "@samdesk/components/Form";
import { InputCheckbox } from "@samdesk/components/InputCheckbox";
import { InputEmail } from "@samdesk/components/InputEmail";
import { InputPassword } from "@samdesk/components/InputPassword";
import { Stack } from "@samdesk/components/Stack";
import { Text } from "@samdesk/components/Text";
import { useEffect, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { withErrorBoundary } from "utils/ErrorBoundary";

import { messageSx, linkSx, wrapperSx } from "router/authStyles";
import useController from "./useController";

const Index = () => {
	const { errorMessage, handleSignin, ssoLink } = useController();
	const location = useLocation();
	const navigate = useNavigate();
	const [successMessage] = useState(
		(location.state as { successMessage?: string } | null)?.successMessage
	);

	useEffect(() => {
		if (location.state) {
			navigate(location.pathname + location.search, {
				replace: true,
				state: null,
			});
		}
	}, [location, navigate]);

	return (
		<Box sx={wrapperSx}>
			<Stack spacing="large">
				<Form onSubmit={handleSignin}>
					<Stack spacing="large">
						<Stack spacing="base">
							<InputEmail
								autoComplete="email"
								label="Email"
								name="email"
								rules={{ required: "Email is required" }}
							/>
							<InputPassword
								autoComplete="current-password"
								label="Password"
								name="password"
								rules={{ required: "Password is required" }}
							/>
							{errorMessage ?
								<Box sx={messageSx}>
									<Text accent="error">{errorMessage}</Text>
								</Box>
							:	successMessage && (
									<Box sx={messageSx}>
										<Text accent="success">{successMessage}</Text>
									</Box>
								)
							}
						</Stack>
						<Box sx={signinButtonWrapperSx}>
							<InputCheckbox
								label="Keep me signed in"
								name="rememberMe"
								value
							/>
							<Button label="Sign in" prominence="primary" submit />
						</Box>
					</Stack>
				</Form>
				<Stack alignItems="center" spacing="smaller">
					<Link
						component={RouterLink}
						sx={linkSx}
						to={ssoLink}
						underline="none"
					>
						Sign in with SSO
					</Link>
					<Link
						component={RouterLink}
						sx={linkSx}
						to="/reset_password"
						underline="none"
					>
						Forgot password?
					</Link>
				</Stack>
			</Stack>
		</Box>
	);
};

export default withErrorBoundary(Index);

/** Style */

const signinButtonWrapperSx = {
	alignItems: "center",
	display: "flex",
	justifyContent: "space-between",
};
